import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

function DisclosureButtons({
  onDownload,
  onBack,
  onRestart,
  onCreateContract,
  className = "",
}) {
  const navigate = useNavigate();
  const { logout } = useContext(UserContext);

  const handleLogout = () => {
    // Reset all data first
    onRestart();
    // Then logout and navigate
    logout();
    navigate("/");
  };

  return (
    <div className={className}>
      <button
        className="btn btn-primary me-2"
        onClick={onDownload}
        title="Download this page as a PDF"
      >
        Download
      </button>
      {onCreateContract && (
        <button
          className="btn btn-success text-white me-2"
          onClick={onCreateContract}
          title="Create a contract for this disclosure"
        >
          Create Contract
        </button>
      )}
      <button
        className="btn btn-secondary me-2"
        onClick={onBack}
        title="Go back to the previous page"
      >
        Back
      </button>
      <button
        className="btn btn-secondary me-2"
        onClick={onRestart}
        title="Restart the vehicle submission process"
      >
        Restart
      </button>
      <button
        className="btn btn-outline-primary"
        onClick={handleLogout}
        title="Logout of the application"
      >
        Logout
      </button>
    </div>
  );
}

export default DisclosureButtons;
